/**
 * ReciboDoAviso — depois de salvar, diz se o robô reagiu (spec
 * 2026-09-24-robo-painel-de-ajustes, 4.7). Consulta o recibo a cada 1 s, por
 * até 25 s, e para sozinho quando ele fecha.
 */
import { useEffect, useState } from 'react'
import { Alert } from '@mantine/core'
import { IconAlertTriangle, IconCheck, IconClock } from '@tabler/icons-react'

import {
  RECIBO_PRAZO_MS, useReciboDoAviso, type AvisoDoAjuste,
} from '@/api/robo'
import { mensagemDoAviso } from './avisoDoAjuste'

const COR = { reagiu: 'green', aguardando: 'gray', atencao: 'yellow' } as const
const ICONE = { reagiu: IconCheck, aguardando: IconClock, atencao: IconAlertTriangle } as const

export function ReciboDoAviso({ aviso, caminho, robo }: {
  aviso: AvisoDoAjuste
  /** `GET` do recibo; `null` quando não há o que consultar (sem `id`). */
  caminho: string | null
  /** Rótulo de `rotuloDoRobo`: "Robô II", ou "robô". */
  robo: string
}) {
  const [desde] = useState(() => Date.now())
  const [prazoPassou, setPrazoPassou] = useState(false)
  const consulta = useReciboDoAviso(aviso.id ? caminho : null, desde)

  useEffect(() => {
    const t = setTimeout(() => setPrazoPassou(true), RECIBO_PRAZO_MS)
    return () => clearTimeout(t)
  }, [])

  const { tom, texto } = mensagemDoAviso(aviso, consulta.data, robo, prazoPassou)
  const Icone = ICONE[tom]
  return (
    <Alert color={COR[tom]} icon={<Icone size={18} />} role="status" aria-live="polite">
      {texto}
    </Alert>
  )
}
